import { render, staticRenderFns } from "./View.vue?vue&type=template&id=50134edb&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50134edb",
  null
  
)

component.options.__file = "View.vue"
export default component.exports